import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const NoteUserIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 3L14.82 3C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3L5 3C3.9 3 3 3.9 3 5L3 19C3 20.1 3.9 21 5 21L19 21C20.1 21 21 20.1 21 19L21 5C21 3.9 20.1 3 19 3ZM12 2.75C12.22 2.75 12.41 2.85 12.55 3C12.67 3.13 12.75 3.31 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25S11.25 3.91 11.25 3.5C11.25 3.31 11.33 3.13 11.45 3C11.59 2.85 11.78 2.75 12 2.75ZM19 19L5 19L5 5L19 5L19 19ZM12 6C10.35 6 9 7.35 9 9S10.35 12 12 12S15 10.65 15 9S13.65 6 12 6ZM12 10C11.45 10 11 9.55 11 9S11.45 8 12 8S13 8.45 13 9S12.55 10 12 10ZM6 16.47L6 18L18 18L18 16.47C18 13.97 14.03 12.89 12 12.89S6 13.96 6 16.47ZM8.31 16C9 15.44 10.69 14.88 12 14.88S15.01 15.44 15.69 16L8.31 16Z"
      fill="currentColor"
    />
  </svg>
);

NoteUserIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(NoteUserIcon);
